import React from 'react'
import {
    Avatar,
    Box,
    Button,
    Card,
    Checkbox,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';
import { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar'
import DeleteIcon from '@mui/icons-material/Delete';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { esES } from '@mui/material/locale';


const ListaUsuarios = (props) => {


    const {usuarios, handleButton} = props;

    const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(0);

    const theme = createTheme(
        {
        palette: {
            primary: {
              light: "#F22E52",
              main: "#39aa28",
              dark: "#408036",
              contrastText: "#fff",
            },
            secondary: {
              light: "#ffffff",
              main: "#B3223C",
              dark: "#cccccc",
              contrastText: "#ff802e",
            },
            default: {
              light: "#ffffff",
              main: "#ffffff",
              dark: "#cccccc",
              contrastText: "#ff802e",
        
            }
          },
        },
        esES,
    );

    
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    return (
        <ThemeProvider theme={theme}>
            <Card>
                <PerfectScrollbar>
                    <Box sx={{ minWidth: 1050 }}>
                    <Table>
                        <TableHead>
                        <TableRow>
                            <TableCell>
                                ID
                            </TableCell>
                            <TableCell>
                                Email
                            </TableCell>
                            <TableCell>
                                Fecha registro
                            </TableCell>
                            <TableCell>
                                Rol
                            </TableCell>
                            <TableCell>
                                Acciones
                            </TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {usuarios.slice(page* limit, page*limit+limit).map((user, index) => (
                            <TableRow
                            hover
                            key={index}
                            selected={selectedCustomerIds.indexOf(user.id) !== -1}
                            >
                            <TableCell>
                                <Box
                                    sx={{
                                        alignItems: 'center',
                                        display: 'flex'
                                    }}
                                    >
                                <Typography
                                    color="textPrimary"
                                    variant="body1"
                                    >
                                    {user.uid}
                                </Typography>
                                </Box>
                            </TableCell>
                            <TableCell>
                                {user.email}
                            </TableCell>
                            <TableCell>
                                {user.registro}
                            </TableCell>
                            <TableCell>
                                {user.rol}
                            </TableCell>
                            <TableCell>
                                <Tooltip title='Añadir administrador'>
                                    <IconButton
                                        onClick={()=>{handleButton(user.id)}}
                                        color='primary'
                                        >
                                        <AddModeratorIcon/>
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                    </Box>
                </PerfectScrollbar>
                <TablePagination
                    component="div"
                    count={usuarios.length}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleLimitChange}
                    page={page}
                    rowsPerPage={limit}
                    rowsPerPageOptions={[5, 10, 25]}
                    />
            </Card>
        </ThemeProvider>
    )
}

export default ListaUsuarios